import { TemplateConfig } from '../../../template-config.interface';
import { PLAYER_VS_PLAYER_LEAGUES } from './leagues';

export const disneyEspnPlayerVSPlayer: TemplateConfig = {
  id: 'espn/espn-vs/futbol',
  clientId: 'DISNEY',
  title: 'Miniatura con jugadores',
  description: 'Enfrentamiento entre dos jugadores de diferentes equipos',
  templateFamily: 'espn-vs-miniatura',
  aspectRatio: 'horizontal',
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/player-vs-player.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/player-vs-player.png',

  bannerType: 'espn/espn-vs/futbol',
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'league',
      label: 'Liga',
      type: 'select',
      required: true,
      options: PLAYER_VS_PLAYER_LEAGUES.map(league => ({
        value: league.value,
        label: league.label
      }))
    },
    {
      key: 'team1',
      label: 'Equipo 1',
      type: 'select',
      options: [], // Se populan dinámicamente según la liga seleccionada
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team2']
    },
    {
      key: 'player1',
      label: 'Jugador 1',
      type: 'select',
      options: [], // Se populan dinámicamente según el equipo 1 seleccionado
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['player2']
    },
    {
      key: 'team2',
      label: 'Equipo 2',
      type: 'select',
      options: [], // Se populan dinámicamente según la liga seleccionada
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team1']
    },
    {
      key: 'player2',
      label: 'Jugador 2',
      type: 'select',
      options: [], // Se populan dinámicamente según el equipo 2 seleccionado
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['player1']
    }
  ],

  promptTemplate: `Haceme una "miniatura con jugadores" de LaLiga con los jugadores Kylian Mbappé y Julián Álvarez`
};
